export const bootstrapLg = 1200;
export const bootstrapMd = 992;
export const bootstrapSm = 768;
export const bootstrapXs = 576;

export const borderDark = '#c3c3c3';
export const chatamsBlue = '#154488';
